import Vue from 'vue';
import FloatingVue from 'floating-vue';

Vue.use(FloatingVue);
